import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CategorySelect } from "@/components/categories";
import { FormatPreview } from "@/components/FormatPreview";
import { Upload } from "lucide-react";

export const UploadCategoryDialog = ({ files, categories, onCancel, onConfirm, onReplace }) => {
  const [cat, setCat] = useState("");
  useEffect(() => { if (files) setCat(""); }, [files?.length]); // eslint-disable-line react-hooks/exhaustive-deps
  const count = files?.length || 0;

  return (
    <Dialog open={!!files} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="max-w-2xl" data-testid="upload-category-dialog">
        <DialogHeader>
          <DialogTitle>Quelle catégorie pour {count > 1 ? `ces ${count} images` : "cette image"} ?</DialogTitle>
          <DialogDescription>La catégorie est obligatoire. Les images seront placées avec les autres images de cette catégorie dans le bandeau.</DialogDescription>
        </DialogHeader>
        <FormatPreview files={files} onReplace={onReplace} />
        <CategorySelect categories={categories} value={cat} onChange={setCat} required testId="upload-category-select" />
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} data-testid="upload-category-cancel">Annuler</Button>
          <Button onClick={() => onConfirm(files, cat)} disabled={!cat} data-testid="upload-category-confirm">
            <Upload className="mr-1 h-4 w-4" /> Ajouter {count > 1 ? `les ${count} images` : "l'image"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
